import React, { useCallback, useEffect, useState } from "react";
import Loading from "../../Extra/Loading";
import "./table.css";
import { useGlobalContext } from "../../Context/GlobalContext";
import TooltipHeader from "../../Extra/TooltipHeader";
import { formatDateToDis } from "../../Utilitie";

const LostTrainAvoidableUnavoidable = () => {
  const { globalDate } = useGlobalContext();
  const [lostTrainData, setLostTrainData] = useState({});
  const [mergedData, setMergedData] = useState({});
  const [dateData, setDateData] = useState(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [todaysTotal, setTodaysTotal] = useState(0);
  const [monthsTotal, setMonthsTotal] = useState(0);
  const [lastYearsTotal, setLastYearsTotal] = useState(0);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(false);
    const url = `${process.env.REACT_APP_URL_PREFIX}pplostwithmppcode/date?date=${globalDate}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.token}`,

          "Content-Type": "application/json",
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();

      setLostTrainData(data?.result?.data);
      setMergedData({
        Unavoidable: mergeByDetCode(data?.result?.data.Unavoidable),
        Avoidable: mergeByDetCode(data?.result?.data.Avoidable),
      });
      setDateData(data?.result?.dateData);
    } catch (error) {
      console.error("Error fetching data:", error);
      setError(true);
    } finally {
      setLoading(false);
    }
  }, [globalDate]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const mergeByDetCode = (array) => {
    const map = new Map();
    array.forEach((item) => {
      const key = item.DET_CODE;

      if (map.has(key)) {
        const existing = map.get(key);
        existing.provided_date_train_count += item.provided_date_train_count;
        existing.month_train_count += item.month_train_count;
        existing.year_train_count += item.year_train_count;
        existing.prev_year_train_count += item.prev_year_train_count;
      } else {
        const { SUB_CODE, Sub_code_desc, ...rest } = item;
        map.set(key, { ...rest });
      }
    });
    return Array.from(map.values());
  };

  useEffect(() => {
    if (mergedData) {
      let tdTotal = 0;
      let mTotal = 0;
      let lfyTotal = 0;
      Object.values(mergedData).forEach((arrayOfObj) => {
        arrayOfObj?.forEach((obj) => {
          tdTotal += Number(obj.provided_date_train_count) || 0;
          mTotal += Number(obj.month_train_count) || 0;
          lfyTotal += Number(obj.prev_year_train_count) || 0;
        });
      });

      setTodaysTotal(tdTotal);
      setMonthsTotal(mTotal);
      setLastYearsTotal(lfyTotal);
    }
  }, [mergedData]);

  return (
    <div className="table-container newUiBody">
      {loading ? <Loading /> : null}
      <div className="table-responsive">
        {Object.keys(lostTrainData).length === 0 ? (
          "No Data Found"
        ) : (
          <table
            className="table  table-striped table-hover table-bordered mb-0"
            style={{ fontSize: "11px", fontWeight: "bold" }}
          >
            <thead>
              <tr className="table-dark">
                <th className="sticky-col first-col">
                  Lost Train {formatDateToDis(globalDate)}
                </th>
                {Object.entries(mergedData).map(
                  ([lostType, arrayOfObj], index) => (
                    <th key={index} colSpan={arrayOfObj.length}>
                      {lostType}
                    </th>
                  )
                )}
                <th className="sticky-col last-col">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="sticky-col first-col">Date</td>
                {Object.entries(mergedData).map(([lostType, arrayOfObj]) =>
                  arrayOfObj.map((obj, ind) => (
                    <td
                      key={ind}
                      style={{
                        background:
                          lostType === "Avoidable" ? "#eafcec" : "#fcedea",
                      }}
                    >
                      {obj.DET_CODE}
                    </td>
                  ))
                )}
                <td className="sticky-col last-col"></td>
              </tr>
              <tr>
                <td className="sticky-col first-col d-flex justify-content-center p-0">
                  <TooltipHeader
                    id={`tooltip-1`}
                    label={dateData?.Input_date}
                    tooltip="Today"
                    type="td"
                  />
                </td>

                {Object.entries(mergedData).map(([lostType, arrayOfObj]) =>
                  arrayOfObj.map((obj, ind) => (
                    <td
                      key={ind}
                      style={{
                        background:
                          lostType === "Avoidable" ? "#eafcec" : "#fcedea",
                      }}
                    >
                      {obj.provided_date_train_count}
                    </td>
                  ))
                )}

                <td className="sticky-col last-col">{todaysTotal}</td>
              </tr>

              <tr>
                <td className="sticky-col first-col  d-flex justify-content-center p-0">
                  <TooltipHeader
                    id={`tooltip-1`}
                    label={dateData?.Month_cumulative?.slice(0, 7)}
                    tooltip="This month"
                    type="td"
                  />
                </td>
                {Object.entries(mergedData).map(([lostType, arrayOfObj]) =>
                  arrayOfObj.map((obj, ind) => (
                    <td
                      key={ind}
                      style={{
                        background:
                          lostType === "Avoidable" ? "#eafcec" : "#fcedea",
                      }}
                    >
                      {obj.month_train_count}
                    </td>
                  ))
                )}
                <td className="sticky-col last-col">{monthsTotal}</td>
              </tr>
              <tr>
                <td className="sticky-col first-col   d-flex justify-content-center p-0">
                  <TooltipHeader
                    id={`tooltip-1`}
                    label={dateData?.Previous_financial_year}
                    tooltip="cumulative data form last financial year"
                    type="td"
                  />
                </td>

                {Object.entries(mergedData).map(([lostType, arrayOfObj]) =>
                  arrayOfObj.map((obj, ind) => (
                    <td
                      key={ind}
                      style={{
                        background:
                          lostType === "Avoidable" ? "#eafcec" : "#fcedea",
                      }}
                    >
                      {obj.prev_year_train_count}
                    </td>
                  ))
                )}
                <td className="sticky-col last-col">{lastYearsTotal}</td>
              </tr>
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default LostTrainAvoidableUnavoidable;
